/**
 * 独享容器「出口」：默认（节点直连）或经 Cloudflare WARP（IPv4 / IPv6 / 双栈）。
 * 用户详情与后台抽屉共用；onSave(mode, fallback) 返回 { status, msg, data }。
 */
import React, { useEffect, useState } from 'react';
import { Button, Card, Checkbox, Select, Space, Tag, Tooltip, Typography, message } from 'antd';
import { useTranslation } from '../../i18n';
import { isOk, errMsg } from '../../services/containerService';

const { Text } = Typography;

export const EGRESS_MODES = [
    { value: 'off', label: '默认' },
    { value: 'v4', label: 'WARP（IPv4）' },
    { value: 'v6', label: 'WARP（IPv6）' },
    { value: 'dual', label: 'WARP（双栈）' },
];

const EgressCard = ({ egress, onSave, onSaved }) => {
    const { t } = useTranslation();
    const e = egress || {};
    const [mode, setMode] = useState(e.mode || 'off');
    const [fallback, setFallback] = useState(!!e.fallback);
    const [saving, setSaving] = useState(false);
    useEffect(() => { setMode(e.mode || 'off'); setFallback(!!e.fallback); }, [e.mode, e.fallback]);

    const locked = !e.available && (e.mode || 'off') === 'off';
    const dirty = mode !== (e.mode || 'off') || (mode !== 'off' && fallback !== !!e.fallback);
    const restarts = (mode === 'v6' || mode === 'dual') !== (e.mode === 'v6' || e.mode === 'dual');
    const save = async () => {
        setSaving(true);
        const r = await onSave(mode, mode === 'off' ? false : fallback);
        setSaving(false);
        if (isOk(r)) { message.success(t('Saved')); onSaved?.(); } else message.error(errMsg(r, t('Failed to save')));
    };
    const exits = [e.exit_ip4, e.exit_ip6].filter(Boolean);

    return (
        <Card size="small" title={<Tooltip title={t('Reach the internet through Cloudflare WARP; inbound traffic is unaffected')}>{t('Egress')}</Tooltip>}
            extra={e.mode && e.mode !== 'off' && e.healthy !== null && e.healthy !== undefined
                && <Tag color={e.healthy ? 'success' : 'error'}>{e.healthy ? t('WARP up') : t('WARP down')}</Tag>}>
            <Space wrap align="center">
                <Select style={{ width: 170 }} value={mode} onChange={setMode} disabled={locked}
                    options={EGRESS_MODES.map((m) => ({ value: m.value, label: t(m.label), disabled: m.value !== 'off' && !e.available }))} />
                {mode !== 'off' && (mode === 'v4' || mode === 'dual') && (
                    <Tooltip title={t('By default no internet while WARP is down; IPv6 only goes through WARP')}>
                        <Checkbox checked={fallback} onChange={(x) => setFallback(x.target.checked)}>{t('Go direct when down')}</Checkbox>
                    </Tooltip>
                )}
                <Tooltip title={restarts ? t('Switching IPv6 restarts the container') : undefined}>
                    <Button type="primary" onClick={save} loading={saving} disabled={!dirty}>{t('Save')}</Button>
                </Tooltip>
                {locked && e.reason && <Text type="secondary">{t(e.reason)}</Text>}
                {exits.length > 0 && <Text type="secondary">{t('Egress IP')}: <Text code>{exits.join(' / ')}</Text></Text>}
            </Space>
        </Card>
    );
};

export default EgressCard;
